var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.quotes),function(quote,index){return _c('app-quote',{key:index,nativeOn:{"click":function($event){return _vm.deleteQuote(index)}}},[_vm._v(_vm._s(quote)+", "+_vm._s(index))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b18d2ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuoteGrid.vue
// module id = 572
// module chunks = 0